import React, { useState, useEffect } from 'react';
import "./SectionThree.scss";
import { Description, GreenSubDescription, PaymentPendingHeading } from '../../../../../Global/GlobalText';
import { CheckboxInput } from '../../../../../Global/GlobalFormElement';
import { GreyBorderButton, RedBackgroundButton } from '../../../../../Global/GlobalButton';
import { EXCHNAGE_URL } from '../../../../../../Url/Url';
import { useSelector } from 'react-redux';

export const SectionThree = ({ setSelectedButton , handleCheckboxChange, selectedRounds,selectedRoundId }) => {
  const [rounds, setRounds] = useState([]);
  // const [selectedRounds, setSelectedRounds] = useState([]);
  // const [selectedRoundId, setSelectedRoundId] = useState("")
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const eventId = String(eventIdGet);
  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`,{
          method: 'GET', // or 'POST' depending on your request type
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }
        });
        const result = await response.json();
        if (result.status) {
          setRounds(result.data);
        } else {
          console.error('Failed to fetch rounds:', result.message);
        }
      } catch (error) {
        console.error('Error fetching rounds:', error);
      }
    };

    fetchRounds();
  }, []);

  // const handleCheckboxChange = (roundId) => {
  //   setSelectedRounds((prevSelected) =>
  //     prevSelected.includes(roundId)
  //       ? prevSelected.filter((id) => id !== roundId)
  //       : [...prevSelected, roundId]
  //   );
  //   setSelectedRoundId(roundId)
  // };

  const handleNextClick = () => {
    // Pass selectedRounds to Section 4
    setSelectedButton(4);
    // Optionally, handle the selectedRounds data as needed
    console.log('Selected Rounds:', rounds);
  
  };

  return (
    <div>
      <div className="section_one_three">
        <GreenSubDescription>Please Select Report Format</GreenSubDescription>
        <div className="sectionthree_mainradio">
          <div className="section_three_radio">
            <input type="radio" name="radio" value="Free" defaultChecked />
            <PaymentPendingHeading>Report Type</PaymentPendingHeading>
          </div>
          <div className="section_three_check">
          {rounds.map((round, roundIndex) => (
  <div key={round.roundId} className="section_three_checkbox">
    <Description>{round.round_name}</Description>
    <div>
    <CheckboxInput
        type="checkbox"
        checked={selectedRoundId === round.roundId}
        onChange={() => handleCheckboxChange(round.roundId)}
      />
      {/* <Description>Round {roundIndex + 1}</Description> */}
    </div>
  </div>
))}

          </div>
          <div className="section_three_btn">
            <GreyBorderButton onClick={() => setSelectedButton(2)}>
              Cancel
            </GreyBorderButton>
            <RedBackgroundButton onClick={handleNextClick}>
              Next
            </RedBackgroundButton>
          </div>
        </div>
      </div>
    </div>
  );
};
